import { render, staticRenderFns } from "./CategoriasProducto.vue?vue&type=template&id=70518e80&"
import script from "./CategoriasProducto.vue?vue&type=script&lang=js&"
export * from "./CategoriasProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports